export default __webpack_public_path__ + "static/media/CNo.18-3.56c3e340.jpg";